import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "@sunwing/components/dist/index.css";
import "./styles/styles.scss";
import App from "./App";
import configureAppStore from "./app/store";
import ModalContainer from "components/common/modal/modalContainer";

const store = configureAppStore();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
            <ModalContainer />
        </Provider>
    </React.StrictMode>
);
